import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestProvider, RestService } from '../rest/rest.service';
import { RestfulService } from '../rest/restful';

@Injectable()
export class OrganisationService extends RestfulService<Models.Organisation> {

  constructor(private restService: RestService) {
    super(Models.Organisation);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('organisations');
  }

}
